import React, { useState } from "react";
import { Modal, Button, Image } from "react-bootstrap";
import { amApi } from "../../../../api/apiHelper";

export const SuperAdminDeleteExp = ({ id, active, removeExp }) => {
  const [showDeleteOffer, seShowDeleteOffer] = useState(false);

  const handleCloseDeleteOffer = async () => {
    await amApi.delete(`/experience/${id}`);
    onDeleteNo();
    removeExp(id, active);
  };

  const onDeleteNo = () => {
    seShowDeleteOffer(false);
  };

  const handleShowDeleteOffer = () => {
    seShowDeleteOffer(true);
  };

  return (
    <React.Fragment>
      <Button
        variant="link"
        className="enIconBtn mr-3"
        disabled={false}
        onClick={handleShowDeleteOffer}
      >
        <Image
          src={require("../../../../assets/images/UserManagement/Delete.svg")}
          alt="Delete"
          title="Delete"
          fluid
        />
      </Button>
      <Modal show={showDeleteOffer} onHide={onDeleteNo} centered>
        <Modal.Header className="py-0 pt-2 border-0" closeButton>
          <Modal.Title>Archive Experience</Modal.Title>
        </Modal.Header>
        <Modal.Body className="f16-500">
          Are you sure you want to mark experience as archive?
        </Modal.Body>
        <Modal.Footer className="justify-content-start border-0">
          <Button
            variant="outline-secondary"
            className="btn-lg mr-4 px-5"
            onClick={onDeleteNo}
          >
            No
          </Button>
          <Button
            variant="danger"
            className="btn-lg px-5"
            onClick={handleCloseDeleteOffer}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default SuperAdminDeleteExp;
